import { useState } from "react";
import { personEntries } from "@/mocks/homeData";

export default function PersonSearch() {
  const [name, setName] = useState("");

  return (
    <section id="persons" className="w-full border-b border-background-200/70 bg-background-100 px-4 py-14 md:px-6 md:py-20">
      <div className="mx-auto max-w-6xl">
        <div className="mb-8 md:mb-10">
          <p className="mb-2 flex items-center gap-2 text-xs font-medium text-primary-600 md:text-sm">
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-user-search-line text-base" aria-hidden="true"></i>
            </span>
            模块 04 · 人物黑料查询入口
          </p>
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
            人物黑料查询入口
          </h2>
          <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
            输入人物称呼或别名，查看对应档案卡：相关标签、被提及次数、参与的专题合集与线索时间区间。
          </p>
        </div>

        <form
          className="mb-8 flex w-full flex-col items-stretch gap-2 sm:flex-row md:mb-10"
          onSubmit={(event) => event.preventDefault()}
          role="search"
        >
          <div className="flex h-12 flex-1 items-center gap-2.5 rounded-md border border-background-300/70 bg-background-50 px-4">
            <span className="flex h-5 w-5 items-center justify-center text-foreground-500">
              <i className="ri-user-3-line text-lg" aria-hidden="true"></i>
            </span>
            <input
              type="text"
              name="personName"
              value={name}
              onChange={(event) => setName(event.target.value)}
              placeholder="输入人物姓名、称呼或别名"
              className="w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-500 md:text-base"
            />
          </div>
          <button
            type="submit"
            className="h-12 cursor-pointer whitespace-nowrap rounded-md bg-foreground-950 px-6 text-sm font-semibold text-background-50 transition-colors hover:bg-foreground-800 md:px-8 md:text-base"
          >
            查询人物黑料
          </button>
        </form>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {personEntries.map((person, index) => (
            <a
              key={person.name}
              href="#zones"
              style={{ animationDelay: `${index * 50}ms` }}
              className="animate-fade-up group flex items-center gap-4 rounded-lg border border-background-200/80 bg-background-50 p-4 transition-colors hover:border-primary-300"
            >
              <div className="h-16 w-16 shrink-0 overflow-hidden rounded-md md:h-20 md:w-20">
                <img
                  src={person.avatar}
                  alt={`${person.name} 人物档案`}
                  title={`${person.name} 黑料查询 人物档案`}
                  className="h-full w-full object-cover object-top"
                />
              </div>
              <div className="min-w-0 flex-1">
                <div className="flex items-baseline gap-2">
                  <p className="font-heading text-lg font-bold text-foreground-950">{person.name}</p>
                  <span className="truncate text-xs text-foreground-500">{person.role}</span>
                </div>
                <div className="mt-2 flex flex-wrap gap-1.5">
                  {person.tags.map((tag) => (
                    <span
                      key={tag}
                      className="rounded-full bg-secondary-100 px-2 py-0.5 text-xs font-medium text-secondary-900"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
                <div className="mt-2.5 flex items-center gap-3 text-xs text-foreground-600">
                  <span className="flex items-center gap-1">
                    <span className="flex h-3.5 w-3.5 items-center justify-center">
                      <i className="ri-chat-quote-line text-sm" aria-hidden="true"></i>
                    </span>
                    被提及 {person.mentions}
                  </span>
                  <span className="flex items-center gap-1 font-semibold text-primary-600">
                    <span className="flex h-3.5 w-3.5 items-center justify-center">
                      <i className="ri-fire-line text-sm" aria-hidden="true"></i>
                    </span>
                    热度 {person.heat}
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}